import styled from 'styled-components';
import { Table, token } from '@bynder/design-system';

export const StyledTableCell = styled(Table.Cell)`
    * > div[class^='Subtext'] {
        color: ${token.colorTextMuted};
    }
`;
